import React from 'react';

export interface PricingLineItem {
  label: string;
  amount: string;
  isHighlighted?: boolean;
}

export interface PricingTotal {
  label: string;
  amount: string;
}

interface PricingSummaryProps {
  lineItems: PricingLineItem[];
  total: PricingTotal;
  showHeader?: boolean;
  variant?: 'default' | 'payment';
}

const PricingSummary: React.FC<PricingSummaryProps> = ({
  lineItems,
  total,
  showHeader = false,
  variant = 'default'
}) => {
  const tableClass =
    variant === 'payment'
      ? 'pricing-summary pricing-summary--payment'
      : 'pricing-summary pricing-summary--price';
  return (
    <table className={tableClass}>
      {showHeader && (
        <thead>
          <tr className="pricing-summary__row--total">
            <th className="pricing-summary__cell">Description</th>
            <th className="pricing-summary__cell--amount">Amount</th>
          </tr>
        </thead>
      )}
      <tbody>
        {lineItems.map((item, index) => (
          <tr key={index} className="pricing-summary__row">
            <td
              className={
                item.isHighlighted
                  ? 'pricing-summary__cell--highlighted'
                  : 'pricing-summary__cell'
              }
            >
              {item.label}
            </td>
            <td className="pricing-summary__cell--amount">{item.amount}</td>
          </tr>
        ))}
        <tr
          className="pricing-summary__row--total"
          style={lineItems.length === 0 ? { borderTop: 'none' } : undefined}
        >
          <td className="pricing-summary__cell">{total.label}</td>
          <td className="pricing-summary__cell--total-amount">
            {total.amount}
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default PricingSummary;
